import {SendToKindleService} from "../service/s2k-service";
import {Metrics} from "../metrics/metrics";

/**
 * Fetch the current active window.
 * @return Window
 */
const getActiveWindow = () => {
    return window;
};

/**
 * Fetch the current active document.
 * @return Document
 */
const getActiveDocument = () => {
    return window.document;
};

class State {
    constructor() {
        // Stop re-initialization if this class has already been constructed
        if (this._instance) {
            return this._instance;
        }

        this._instance = this;

        this.stateWindow = getActiveWindow();
        this.stateDocument = getActiveDocument();

        this.isPreviewOnly = false;
        this.isSelectedOnly = false;

        /**
         * @type {boolean}
         */
        this.cancelProgress = false;

        /**
         * @type {boolean}
         */
        this.inProgress = false;

        // These dependencies are populated as-need depending on whether the
        // content script is injected as an extractor/preview page helper/
        // history frame helper
        /**
         * @type {import("../preview/s2k-preview").Preview | undefined}
         */
        this.preview = undefined;

        /**
         * @type {import("../model/document").SendToKindleDocument | undefined}
         */
        this.content = undefined;

        /**
         * @type {import("../status/status-message").StatusMessage | undefined}
         */
        this.statusMessage = undefined;

        /**
         * @type {import("../history/history-overlay").History | undefined}
         */
        this.history = undefined;

        /**
         * Session token for KindleDocsWebService
         * @type {string | undefined}
         */
        this.s2kGuid = undefined;

        /**
         * Flag raised on initalization
         * @type {boolean}
         */
        this.isInjected = false;

        /**
         * Behavior when the extraction engine predicts a low-quality result
         * @type {"ASK" | "PREVIEW" | "SEND"}
         */
        this.lowQualityAction = "ASK";

        /**
         * Whether the content script is being injected due to
         *  - content extraction (ocs)
         *  - preview (preview)
         *  - history frame (history)
         * @type {"ocs" | "preview" | "history"}
         */
        this.injectionContext = "ocs";

        /**
         * e.g. chrome-extension://cgdjpilhipecahhcilnafpblkieebhea
         * @type { string | undefined}
         */
        this.extensionUrl = undefined;
    }

    /**
     *
     * @param {"ocs" | "preview" | "history"} injectionContext
     * @param {string | undefined} s2kGuid
     * @param {string | undefined} extensionId
     * @param {"ASK" | "PREVIEW" | "SEND" | undefined} lowQualityAction
     */
    initialize(injectionContext, s2kGuid, extensionId, lowQualityAction) {
        this.injectionContext = injectionContext;

        this.s2kGuid = s2kGuid ?? undefined;

        if (lowQualityAction) {
            this.lowQualityAction = lowQualityAction;
        }

        if (extensionId) {
            this.extensionUrl = `chrome-extension://${extensionId}`;
        }

        this.isInjected = true;

        // Reset progress state
        this.resetProgress();
    }

    /**
     * Reset the state of progress
     */
    resetProgress() {
        this.cancelProgress = false;
        this.inProgress = false;
        chrome.runtime.sendMessage({
            action: "set-cancel-sending",
            data: {
                cancel: false
            }
        });
    }
}

const _state = new State();
const getState = () => _state;

export {getState, getActiveWindow, getActiveDocument};
